
<div
  :id="pendingSale.itemId"
  v-observe-visibility="visibilityChanged"
  :class="['pending-sale', { alert: hasAlert, warning: hasWarning }]"
>
  <div :class="['wrapper', { visible }]">
    <section class="top">
      <align
        class="header"
        flex
        direction="flex-start"
        small-gap
      >
        <a class="link" :href="`/card/${pendingSale.cardId}?showSales=true`" target="_blank">
          <div><b>{{ pendingSale.cardLabel }}</b></div>
        </a>

        <external-link
          v-if="isEbaySale"
          href="https://130point.com/sales/"
          @click.native="$copyText(pendingSale.title)"
        >
          <span>130</span>
        </external-link>

        <external-link
          v-if="isEbaySale"
          :href="terapeakLink"
        >
          <span>Tera</span>
        </external-link>

        <external-link
          v-if="ebaySearchUrl"
          :href="ebaySearchUrl"
        >
          <span>eBay</span>
        </external-link>

        <external-link
          v-if="salesHistoryUrl"
          :href="salesHistoryUrl"
        >
          <span>Sales</span>
        </external-link>

        <external-link
          v-if="pendingSale.email"
          @click.native="sendEmail"
        >
          Email
        </external-link>
      </align>

      <align direction="flex-start">
        <div class="images-container">
          <a :href="saleUrl" target="_blank">
            <img
              v-if="pendingSale.image"
              v-lazy="{ src: pendingSale.image }"
              class="fade platform-image"
            />
          </a>

          <card-image v-if="pendingSale.cardId" :image-url="cardThumbnail" />
        </div>

        <div class="details-container">
          <a
            v-if="pendingSale.title"
            :href="saleUrl"
            class="link title"
            target="_blank"
          >
            <b>{{ pendingSale.title }}</b>
          </a>

          <div v-if="pendingSale.newestSaleDate">
            <span>Last Sale Date:</span> <b>{{ $filters.date(pendingSale.newestSaleDate) }}</b>
          </div>

          <div>
            <span>End Date:</span> <b>{{ $filters.datetime(pendingSale.date) }}</b>
          </div>

          <div v-if="pendingSale.listingType">
            <span>Type:</span> <b>{{ pendingSale.listingType }}</b> <b v-if="pendingSale.bids">({{ pendingSale.bids }} bids)</b>
          </div>

          <div v-if="platform">
            <span>Platform:</span> <b>{{ platform }}</b>
          </div>

          <div v-if="pendingSale.seller && pendingSale.feedback">
            <span>Seller:</span> <b>{{ pendingSale.seller }} ({{ pendingSale.feedback }})</b>
          </div>

          <div v-if="pendingSale.scrapeSuccess || pendingSale.scrapeFailed">
            <span>Best Offer Status: </span>
            <span v-if="pendingSale.scrapeSuccess" class="success">Success</span>
            <span v-if="pendingSale.scrapeFailed" class="error">Failed</span>
          </div>

          <div v-if="pendingSale.auctionEndedEarly" class="error">
            Auction Ended Early
          </div>

          <div v-if="attributes" class="success">
            {{ attributes }}
          </div>

          <graph
            v-if="sale.cardId && !hideGraph"
            class="pending-sales-graph xlarge-up"
            hide-controls
            scale="linear"
            :labels="labels"
            :datasets="datasets"
            :zoom="92"
          />

          <div v-if="Boolean(pendingSale.notes)" class="pending-sale-notes">
            <div><b>Seller Notes:</b></div>
            <div>{{ pendingSale.notes }}</div>
          </div>

          <div v-if="Boolean(pendingSale.employeeNotes)" class="pending-sale-employee-notes">
            <div><b>Employee Notes:</b></div>
            <div>{{ pendingSale.employeeNotes }}</div>
          </div>
        </div>
      </align>
    </section>

    <div v-if="pendingSale.marketValue">
      <span>Market Value:</span> <b>{{ $filters.currency(pendingSale.marketValue, { full: true }) }}</b>
    </div>

    <div v-if="pendingSale.listPrice">
      <span>List Price:</span> <b>{{ $filters.currency(pendingSale.listPrice, { full: true }) }}</b>
    </div>

    <br />

    <align small-gap>
      <form @submit.prevent="confirmPendingSale">
        <align small-gap>
          <currency-input
            :id="`price-${pendingSale.itemId}`"
            v-model="pendingSale.price"
            label="Price"
          />

          <btn kind="secondary" type="submit">
            Submit
          </btn>
          <icon v-if="pendingSale.verifiedCert" name="check_circle" />
          <icon-button v-if="pendingSale.switchedCardIdFromCert" icon="autorenew" @click="switchBack" />
          <icon v-if="pendingSale.noMatchingCert" name="close" />
        </align>
      </form>

      <align small-gap>
        <icon-button
          tooltip="Delete pending sale"
          icon="delete_outline"
          @click="deletePendingSale"
        />

        <icon-button
          tooltip="Send to purgatory"
          icon="assignment_late"
          @click="sendToPurgatory"
        />

        <icon-button
          tooltip="Flag sale for headlines"
          icon="flag"
          @click="flagForHeadlines"
        />

        <icon-button
          tooltip="Edit Pending Sale"
          class="edit"
          icon="edit"
          @click="editPendingSale"
        />

        <dropdown
          v-if="otherGradeOptions.length && condition"
          align="top-right"
          :active="otherGradesMenuOpen"
          @close="otherGradesMenuOpen = false"
        >
          <grade-variation-chip
            as="button"
            dropdown
            no-color
            :grade="condition"
            @click.native.stop="otherGradesMenuOpen = !otherGradesMenuOpen"
          />

          <template #menu>
            <dropdown-menu
              :options="otherGradeOptions"
              :max-height="200"
              @select="switchCard"
            />
          </template>
        </dropdown>

        <dropdown
          v-if="showVariationsDropdown"
          align="top-right"
          :active="otherVariationsMenuOpen"
          @close="otherVariationsMenuOpen = false"
        >
          <grade-variation-chip
            as="button"
            dropdown
            :variation="variation"
            @click.native.stop="otherVariationsMenuOpen = !otherVariationsMenuOpen"
          />

          <template #menu>
            <dropdown-menu
              :options="otherVariationOptions"
              :max-height="200"
              @select="switchCard"
            />
          </template>
        </dropdown>
      </align>
    </align>
  </div>
</div>
